import styled from "styled-components";
import { theme } from "../../../styling/theme";

export const CaptionSection = styled.div`
  background-color: white;
  border: 0.9px solid ${theme.boxLightBorder};
  border-radius: 10px;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  min-height: 200px;
  max-width: 500px;
  margin-top: 20px;
  padding: 10px;
  white-space: pre-wrap;
`;
